import { Components, Theme } from '@mui/material/styles';
import { flowElevations } from '../theme/theme.elevations';

export const flowPaper: Components<Theme>['MuiPaper'] = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      // Flow elevation shadow variants
      ...(Object.keys(flowElevations).includes(ownerState.variant) && {
        boxShadow: theme.flowShadows[ownerState.variant],
      }),
    }),
    outlined: ({ theme }) => ({
      borderColor: theme.palette.onSurface.os100,
    }),
  },
};
